import { useEffect } from 'react';
import { useUnsavedChanges } from '@/context/UnsavedChangesContext';

export function useFormUnsavedChanges(isDirty: boolean) {
	const { setHasUnsavedChanges } = useUnsavedChanges();

	useEffect(() => {
		setHasUnsavedChanges(isDirty);
	}, [isDirty, setHasUnsavedChanges]);
}
